module.exports = __webpack_public_path__ + "img/logo.10b9842d.png";